import { render, staticRenderFns } from "./SidebarParent.vue?vue&type=template&id=dd7795a0"
import script from "./SidebarParent.vue?vue&type=script&lang=js"
export * from "./SidebarParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports